import { Pie } from 'react-chartjs-2';
import { FaTasks } from 'react-icons/fa';
import { CardBody } from 'reactstrap';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IoMdRefresh } from 'react-icons/io';
import { getDashboardTaskSummary } from '../../../redux/MainAction';

const TaskSummaryChart = () => {
  const dispatch = useDispatch();
  const [firstRefresh, setFirstRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const taskSummary = useSelector(
    (state) => state.Webtracker.dashboardTaskSummary
  );

  const data = {
    labels: ['Open', 'In-Progress', 'Done', 'Closed'],
    datasets: [
      {
        data: [
          taskSummary?.open,
          taskSummary?.inProgress,
          taskSummary?.done,
          taskSummary?.closed,
        ],
        backgroundColor: ['#007bff', '#ffc107', '#28a745', '#E195AB'],
        hoverBackgroundColor: ['#0056b3', '#d39e00', '#1e7e34', '#E195AB'],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 10,
          usePointStyle: true,
        },
      },
    },
  };

  const totalTasks =
    Object.values(taskSummary)?.reduce((acc, curr) => acc + curr, 0) || 1;

  const getProgressWidth = (count) => {
    return `${(count / totalTasks) * 100}%`;
  };

  async function fetchDashboardData(isFirstRefresh) {
    setIsLoading(true);
    if (isFirstRefresh) setFirstRefresh(true);

    await dispatch(getDashboardTaskSummary());

    setIsLoading(false);
  }

  return (
    <div className="card m-b-20 enhanced-card">
      <div className="border_class d-flex align-items-center justify-content-between">
        <h5 className="dash-card-title font-20 ml-3">
          <FaTasks className="font-20 mr-2 mb-1 dash-text-primary" /> Tasks
        </h5>

        {firstRefresh ? (
          <IoMdRefresh
            onClick={fetchDashboardData}
            title="Refresh Data"
            className="dashboard_reload_icon"
          />
        ) : null}
      </div>
      <CardBody className="act_card2 dash_cards">
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="spinner-border text-primary " role="status"></div>
          </div>
        ) : firstRefresh ? (
          <>
            <div style={{ height: '200px' }}>
              <Pie data={data} options={options} />
            </div>

            <div className="d-flex justify-content-between mt-3 border-top border-bottom align-items-center p-3 bg-white">
              <span className="task_no2">Open</span>
              <span className="task_no">{taskSummary?.open}</span>
              <div
                style={{
                  width: '120px',
                  height: '14px',
                  backgroundColor: '#E9ECEF',
                  borderRadius: '10px',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    width: getProgressWidth(taskSummary?.open),
                    height: '100%',
                    backgroundColor: '#007bff',
                  }}
                ></div>
              </div>
            </div>

            <div className="d-flex justify-content-between border-bottom align-items-center p-3 bg-white">
              <span className="task_no2">Closed</span>
              <span className="task_no">{taskSummary?.closed || 0}</span>
              <div
                style={{
                  width: '120px',
                  height: '14px',
                  backgroundColor: '#E9ECEF',
                  borderRadius: '10px',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    width: getProgressWidth(taskSummary?.closed || 0),
                    height: '100%',
                    backgroundColor: '#E195AB',
                  }}
                ></div>
              </div>
            </div>

            <div className="d-flex justify-content-between border-bottom align-items-center p-3 bg-white">
              <span className="task_no2">Done</span>
              <span className="task_no">{taskSummary?.done}</span>
              <div
                style={{
                  width: '120px',
                  height: '14px',
                  backgroundColor: '#E9ECEF',
                  borderRadius: '10px',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    width: getProgressWidth(taskSummary?.done),
                    height: '100%',
                    backgroundColor: '#28a745',
                  }}
                ></div>
              </div>
            </div>

            <div className="d-flex justify-content-between border-bottom align-items-center p-3 bg-white">
              <span className="task_no2">In Progress</span>
              <span className="task_no">{taskSummary?.inProgress}</span>
              <div
                style={{
                  width: '120px',
                  height: '14px',
                  backgroundColor: '#E9ECEF',
                  borderRadius: '10px',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    width: getProgressWidth(taskSummary?.inProgress),
                    height: '100%',
                    backgroundColor: '#ffc107',
                  }}
                ></div>
              </div>
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <button
              className="btn btn-primary font-14"
              onClick={() => fetchDashboardData(true)}
            >
              Load Data
            </button>
          </div>
        )}
      </CardBody>
    </div>
  );
};

export default TaskSummaryChart;
